<template>
    <div class="newPage">

        <div class="content">
            <div class="VOCNavBar" v-if="queryParams">
                <div class="title">参数选择</div>
                <div class="navBarItem">
                    <div class="navBarTitle">开始日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.startTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">结束日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.endTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">数据类型</div>
                    <div class="navBarValue">
                        <el-radio-group v-model="queryParams.type">
                            <el-radio :label="0">原始</el-radio>
                            <el-radio :label="1">审核</el-radio>
                            <el-radio :label="2">全部</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="navBarFlex">
                    <div class="flexItem" @click="timeTypeChange((index+1))" v-for="(item,index) in navList"
                         :key="index">
                        <div class="flexTitle" :class="timeType==(index+1) ? 'active':'' "
                        >{{item.name}}
                        </div>
                    </div>
                    <!--<div class="flexItem" @click="timeTypeChange(1)">-->
                    <!--<div class="flexTitle" :class="queryParams.timeType==1 ? 'active':''"-->
                    <!--&gt;小时数据完整性-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="flexItem" @click="timeTypeChange(2)">-->
                    <!--<div class="flexTitle" :class="queryParams.timeType==2 ? 'active':''"-->
                    <!--&gt;日数据完整性-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="flexItem" @click="timeTypeChange(3)">-->
                    <!--<div class="flexTitle" :class="queryParams.timeType==3 ? 'active':''"-->
                    <!--&gt;月数据完整性-->
                    <!--</div>-->

                    <!--</div>-->
                    <!--<div class="flexItem" @click="timeTypeChange(4)">-->
                    <!--<div class="flexTitle" :class="queryParams.timeType==4 ? 'active':''"-->
                    <!--&gt;年数据完整性-->
                    <!--</div>-->
                    <!--</div>-->
                </div>

                <div class="navBarContent">
                    <div class="flexValue" v-if="timeType ===1">
                        <div class="text"> 小时数据完整性VOCS小时数据内缺失组分不超过
                            <input type="text" v-model="queryParams.hourData"> %
                        </div>
                    </div>
                    <div class="flexValue" v-if="timeType ===2">
                        <div class="text">日小时数据完整性大于 <input type="text" v-model="queryParams.dayData"> 小时</div>
                    </div>
                    <div class="flexValue" v-if="timeType ===3">
                        <div class="text">月数据的完整性应不少于 <input type="text" v-model="queryParams.monthData"> 天</div>
                    </div>
                    <div class="flexValue" v-if="timeType ===4">
                        <div class="text">所有月数据均为有效数据</div>
                    </div>
                </div>


                <div class="title">选择站点</div>
                <div class="statisticBox">
                    <el-checkbox-group v-model="queryParams.stations">
                        <div v-for="(item,index) in addressList" :key="index">
                            <el-checkbox :label='item'>{{item}}</el-checkbox>
                        </div>
                    </el-checkbox-group>

                </div>
                <div class="btnBox">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="getList">查询</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="excelExport">导出</el-button>
                </div>
            </div>
            <div class="showContent">
                <breadcrumb></breadcrumb>
                <div class="VOCContent" v-if="timeType===1">
                    <div class="contentHeader">
                        <div>总条数 : {{ total}}</div>
                        <div>缺失数 :{{miss}}</div>
                    </div>
                    <div class="contentTable" v-if="tableData">
                        <el-table
                                v-loading="loading"
                                size="mini"
                                :data="tableData.list"
                                border
                                style="width: 100%">
                            <el-table-column
                                    fixed
                                    prop="station"
                                    label="站点名称"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    fixed
                                    prop="timePoint"
                                    label="时间"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    v-for="(item,index) in queryList"
                                    :key="index"
                                    :prop="item.mname"
                                    :label="item.name"
                            >
                            </el-table-column>

                        </el-table>

                        <pagination
                                v-show="tableData.totalCount>0"
                                :total="tableData.totalCount"
                                :page.sync="queryParams.page"
                                :limit.sync="queryParams.pageSize"
                                @pagination="getList"
                        />
                    </div>
                </div>
                <div class="VOCContent" v-if="timeType===2">
                    <div class="contentTable" v-if="tableData">
                        <el-table
                                v-loading="loading"
                                size="mini"
                                :data="tableData.list"
                                border
                                style="width: 100%">
                            <el-table-column
                                    prop="station"
                                    label="站点名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="time"
                                    label="时间"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="vaild"
                                    label="有效小时数"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="effec"
                                    label="是否有效"
                            >
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.effec==='否'" type="danger">否</el-tag>
                                    <el-tag v-if="scope.row.effec==='是'" type="success">是</el-tag>
                                </template>
                            </el-table-column>

                        </el-table>

                        <pagination
                                v-show="tableData.totalCount>0"
                                :total="tableData.totalCount"
                                :page.sync="queryParams.page"
                                :limit.sync="queryParams.pageSize"
                                @pagination="getList"
                        />
                    </div>
                </div>
                <div class="VOCContent" v-if="timeType===3">
                    <div class="contentTable" v-if="tableData">
                        <el-table
                                v-loading="loading"
                                size="mini"
                                :data="tableData.list"
                                border
                                style="width: 100%">
                            <el-table-column
                                    prop="station"
                                    label="站点名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="time"
                                    label="时间"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="vaild"
                                    label="有效日"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="effec"
                                    label="是否有效"
                            >
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.effec==='否'" type="danger">否</el-tag>
                                    <el-tag v-if="scope.row.effec==='是'" type="success">是</el-tag>
                                </template>
                            </el-table-column>

                        </el-table>

                        <pagination
                                v-show="tableData.totalCount>0"
                                :total="tableData.totalCount"
                                :page.sync="queryParams.page"
                                :limit.sync="queryParams.pageSize"
                                @pagination="getList"
                        />
                    </div>
                </div>
                <div class="VOCContent" v-if="timeType===4">
                    <div class="contentTable" v-if="tableData">
                        <el-table
                                v-loading="loading"
                                size="mini"
                                :data="tableData.list"
                                border
                                style="width: 100%">
                            <el-table-column
                                    prop="station"
                                    label="站点名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="time"
                                    label="时间"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="vaild"
                                    label="有效月"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="effec"
                                    label="是否有效"
                            >
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.effec==='否'" type="danger">否</el-tag>
                                    <el-tag v-if="scope.row.effec==='是'" type="success">是</el-tag>
                                </template>
                            </el-table-column>

                        </el-table>

                        <pagination
                                v-show="tableData.totalCount>0"
                                :total="tableData.totalCount"
                                :page.sync="queryParams.page"
                                :limit.sync="queryParams.pageSize"
                                @pagination="getList"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import url from "../../../utils/UrlApi"
    import Breadcrumb from "../../../components/breadcrumb";

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "IntegrityAnalysis",
        components: {Breadcrumb},
        data() {
            return {
                queryParams: {
                    rateType: '1',
                    stations: [],
                    voc: '',
                    type: 1,
                    page: 1,
                    pageSize: 10,
                    timeType: 1
                },
                loading: false,
                // queryParams:null,
                timeType: 1,
                addressList: [],
                tableData: null,
                queryList: [],
                total: "",
                miss: '',
                navList: [
                    {name: '小时数据完整性'},
                    {name: '日数据完整性'},
                    {name: '月数据完整性'},
                    {name: '年数据完整性'},
                ]
            }
        },
        created() {
            // this.getList()
            this.getParams()
            this.getaddresstree()
            this.getqueryList()
        },
        methods: {
            getParams() {
                let data = {}
                this.$http.get(url.getSelectUse, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        if (res.data.data) {
                            this.queryParams = res.data.data
                            this.queryParams.stations = res.data.data.stations.split(',')
                            this.queryParams.timeType = 1

                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getList() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.stations = this.queryParams.stations.join()
                data.timeType = this.timeType
                this.loading = true
                this.$http.get(url.vocDataCompleteness, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.loading = false
                        this.tableData = res.data.data.list
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            //  获取 站点数据
            getaddresstree() {
                let data = {}
                this.$http.get(url.vocDataAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)

                        this.addressList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getqueryList() {

                let data = {}
                this.$http.get(url.vocDatamapping, data).then(res => {
                    if (res.data.code === '200') {
                        // this.getList()
                        this.queryList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  导出
            excelExport() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.token = localStorage.getItem('token')
                data.stations = this.queryParams.stations.join()
                data.timeType = this.timeType
                let allUrl = url.completenessExcel + params(data)
                window.open(allUrl, '_blank')
            },
            timeTypeChange(index) {
                // console.log(index)
                this.timeType = index
                this.getList()
            }
        }
    }
</script>


<style scoped lang="less">
    @import "../../../assets/vocContent";

    .contentHeader {
        padding: 20px;
        border-bottom: 1px solid #ddd;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        div {
            flex: 1;
        }
    }
</style>